// /careers — hub (RU).
import { createFileRoute } from "@tanstack/react-router";
import { HubPage } from "@/careers/HubPage";
import { careersHead } from "@/careers/head";
import { UI } from "@/careers/spheres";

const ALT = { az: "/az/careers", ru: "/careers", en: "/en/careers" } as const;

export const Route = createFileRoute("/careers/")({
  head: () =>
    careersHead({
      lang: "ru",
      canonicalPath: "/careers",
      altPaths: ALT,
      title: UI.ru.metaTitleHub,
      description: UI.ru.metaDescHub,
    }),
  component: () => <HubPage lang="ru" />,
});
